import React, { useCallback } from 'react';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import { RightRow, StatusRow, Status, StatusRow1, CircleIcon, LabelGroup } from './styles';
import {
  BUTTON_TYPE,
  ICON_BUTTON_SIZE,
  ICON_BUTTON_TYPE,
  ICON_SIZE,
  LABEL_COLOUR_HASH,
  MENU_OPTIONS
} from '../../../global/constants';
import { Autotext, Box, LabelTitle, LeftRow, Row, Subtitle, Title } from '../styles';
import Button from '../../button';
import { Label } from '../../../mobx/interfaces/project';
import { Dropdown, DropdownItem } from '../../dropdown';
import { observer } from 'mobx-react-lite';
import { rootStore } from '../../../mobx/rootStore';
import IconButton from '../../button/iconButton';
import SwitchInput from '../../input/switchInput';

interface Props {
  onUpdateLabels: (value: boolean) => void;
  openDeleteLabelModel: (id: string) => void;
  onClickEditLabel: (item: Label) => void;
  handleclick: () => void;
  loadingButton: boolean;
  isTemplateProject?: boolean;
}

const LabelsSettingCard: React.FC<Props> = (props) => {
  const { onUpdateLabels, openDeleteLabelModel, onClickEditLabel, handleclick, loadingButton, isTemplateProject } =
    props;

  //Mobx store variables
  const { projectStore, projectTemplateStore } = rootStore;
  const { currentProject: projectDetails } = projectStore;
  const { currentProjectTemplate } = projectTemplateStore;
  const currentProject = isTemplateProject ? currentProjectTemplate : projectDetails;

  //Other variables
  const menuItems = [
    {
      key: MENU_OPTIONS.EDIT,
      label: 'Edit'
    },
    {
      key: MENU_OPTIONS.DELETE,
      label: 'Delete'
    }
  ];

  const handleDropdownClick = useCallback(
    (key: string | number, item: Label) => {
      key = Number(key);
      if (key === MENU_OPTIONS.EDIT) {
        onClickEditLabel(item);
      } else if (key === MENU_OPTIONS.DELETE) {
        openDeleteLabelModel(item?.id);
      }
    },
    [onClickEditLabel, openDeleteLabelModel]
  );
  return (
    <Box>
      <Row>
        <LeftRow>
          <Title>Labels</Title>
          <Subtitle>Enhance task management by creating and applying labels to categorise tasks.</Subtitle>
        </LeftRow>
        <Autotext>
          {loadingButton ? (
            <Button variant={BUTTON_TYPE.PRIMARY} isLoading={loadingButton} />
          ) : (
            <SwitchInput
              checked={currentProject?.labelsEnabled || false}
              onChange={() => onUpdateLabels(!currentProject?.labelsEnabled)}
            />
          )}
        </Autotext>
      </Row>
      {currentProject?.labelsEnabled && (
        <Status>
          {currentProject?.labelsList?.length > 0 &&
            currentProject?.labelsList?.map((item, index: number) => {
              return (
                <StatusRow key={item?.id}>
                  <RightRow>
                    <CircleIcon color={`${LABEL_COLOUR_HASH[item?.color]}`} />
                    <LabelTitle>{item?.name}</LabelTitle>
                  </RightRow>
                  <Dropdown
                    modalTitle='Label'
                    activeClassName='active-state'
                    content={
                      <IconButton
                        iconName='three-dots-horizontal-icon'
                        size={ICON_BUTTON_SIZE.SMALL}
                        variant={ICON_BUTTON_TYPE.TERTIARY}
                      />
                    }>
                    {menuItems.map((menuItem) => (
                      <DropdownItem
                        key={menuItem.key}
                        label={menuItem.label}
                        onClick={() => handleDropdownClick(menuItem.key, item)}
                        tone={menuItem.label === 'Delete' ? 'critical' : 'primary'}
                      />
                    ))}
                  </Dropdown>
                </StatusRow>
              );
            })}
          <StatusRow1 role='button' onClick={handleclick}>
            <LabelGroup>
              <SVGIcon
                name='plus-icon'
                width={ICON_SIZE.MD}
                height={ICON_SIZE.MD}
                viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                fill='var(--text-secondary)'
              />
              <p>Create New Label</p>
            </LabelGroup>
          </StatusRow1>
        </Status>
      )}
    </Box>
  );
};

export default observer(LabelsSettingCard);
